import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useCallback, useMemo } from "react";
import { useStoreState } from "pullstate";
import { useAuth } from "@qure/qure-auth";
import { get } from "lodash";
import { OrqClient } from "../../../services/orq";
import Store from "../../../utils/Store";
import getEnv from "../../../utils/getEnv";

/**
 * Bridges the app to the orqestrator client.
 *
 * useOrqChat knows only `(prompt, onDelta, signal) => Promise<void>`. Everything
 * orqestrator-shaped lives on this side of that line: the base URL, the project,
 * the agent slug, and the conversation id that turns a series of one-shot calls
 * into a thread.
 *
 * Reading order from here: OrqClient.streamChat in services/orq/client.ts, then
 * readJSONEvents in sse.ts for the wire format.
 */

/**
 * Where each patient's conversation id survives a page reload.
 *
 * orqestrator has no "list my conversations" endpoint, so if the browser
 * forgets an id the thread is unreachable even though the server still holds
 * it. Kept in localStorage so it survives a reload, and mirrored in memory so
 * it also survives private mode, where storage throws.
 *
 * Keyed per patient. The chat is mounted app-wide and the selection changes
 * underneath it, so a single key meant switching patients kept pointing at the
 * previous patient's thread and carried their history into the new chat. Per
 * patient, each conversation stays resumable and none of them bleed into each
 * other. Chats opened with no patient selected share the "none" bucket.
 *
 * `newThread()` removes the current patient's entry, which is what makes
 * "New chat" actually start a new one rather than hiding the old.
 */
var THREAD_KEY_PREFIX = "orq.conversationId";
function threadKey(patientUid) {
  return "".concat(THREAD_KEY_PREFIX, ".").concat(patientUid !== null && patientUid !== void 0 ? patientUid : "none");
}
var threadsInMemory = new Map();
function rememberThread(patientUid, id) {
  var key = threadKey(patientUid);
  threadsInMemory.set(key, id);
  try {
    if (id) window.localStorage.setItem(key, id);else window.localStorage.removeItem(key);
  } catch (_unused) {
    // Private mode or storage disabled. The in-memory copy still keeps the
    // thread alive for this session, it just will not survive a reload.
  }
}
function recallThread(patientUid) {
  var key = threadKey(patientUid);
  // Memory first: it is authoritative once this session has written to it, and
  // it is the only copy when storage is unavailable.
  if (threadsInMemory.has(key)) return threadsInMemory.get(key);
  if (typeof window === "undefined") return undefined;
  try {
    var _window$localStorage$;
    return (_window$localStorage$ = window.localStorage.getItem(key)) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : undefined;
  } catch (_unused2) {
    return undefined;
  }
}
export function useOrqTransport() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  // The patient on screen, so patient-scoped tools know who is meant. Read from
  // the store rather than passed in, because the chat is mounted app-wide and
  // the selection changes underneath it.
  var patientDetail = useStoreState(Store, function (s) {
    return s.patientDetail;
  });

  // The numeric patient PK, which is `patient_uid` — not `id` (undefined on
  // patientDetail) and not `patient_id`, which is the human-readable identifier
  // ("SEED003"). orqestrator types the request field as an int, so the readable
  // one is a 422 (`int_parsing`) before any tool runs, and the platform's own
  // tool URLs address patients by the uid anyway.
  //
  // Also the thread key, so the conversation follows the patient on screen.
  var patientUid = get(patientDetail, ["patient_uid"]);
  var client = useMemo(function () {
    var _getEnv, _getEnv2;
    return new OrqClient({
      baseUrl: String((_getEnv = getEnv("NEXT_PUBLIC_ORQ_BASE_URL")) !== null && _getEnv !== void 0 ? _getEnv : ""),
      projectId: String((_getEnv2 = getEnv("NEXT_PUBLIC_ORQ_PROJECT_ID")) !== null && _getEnv2 !== void 0 ? _getEnv2 : "")
    });
  }, []);
  var transport = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(prompt, events, signal) {
      var _getEnv3;
      var slug, workspaceId, accountId, result;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            slug = String((_getEnv3 = getEnv("NEXT_PUBLIC_ORQ_AGENT_SLUG")) !== null && _getEnv3 !== void 0 ? _getEnv3 : ""); // Fail loudly rather than posting to "/api/v1/orchestrate" on an empty
            // origin, which surfaces as an opaque network error.
            if (!(!slug || !getEnv("NEXT_PUBLIC_ORQ_BASE_URL"))) {
              _context.n = 1;
              break;
            }
            throw new Error("orq chat is enabled but not configured: set NEXT_PUBLIC_ORQ_BASE_URL, " + "NEXT_PUBLIC_ORQ_PROJECT_ID and NEXT_PUBLIC_ORQ_AGENT_SLUG");
          case 1:
            // Without a workspace the agent still answers, it just cannot use any
            // platform tool — orqestrator's MCP server raises "No workspace ID found".
            workspaceId = get(userInfo, ["default_workspace"]); // Lives under `details`, not at the top level like default_workspace.
            // Without it orqestrator's reminder tool fails with "No account_id found
            // in MCP platform metadata".
            accountId = get(userInfo, ["details", "account_id"]);
            _context.n = 2;
            return client.streamChat({
              slug: slug,
              prompt: prompt,
              // Resolved per turn rather than held in a ref, so a patient switch
              // mid-session picks up that patient's thread with no resync step.
              conversationId: recallThread(patientUid),
              workspaceId: workspaceId,
              patientId: patientUid,
              accountId: accountId
            }, {
              onText: events.onDelta,
              // Three events per tool, each a fuller picture of the same call:
              // the name, then the arguments, then what came back. The UI merges
              // them by id, so a row appears the moment the tool starts rather
              // than after it returns.
              //
              // The result is the tool's own output, not a view of the data: if a
              // tool wrote something, the screen showing that data still refetches.
              onToolStart: function onToolStart(call) {
                var _events$onTool;
                return (_events$onTool = events.onTool) === null || _events$onTool === void 0 ? void 0 : _events$onTool.call(events, {
                  id: call.id,
                  name: call.name,
                  done: false
                });
              },
              onToolEnd: function onToolEnd(call) {
                var _events$onTool2;
                return (_events$onTool2 = events.onTool) === null || _events$onTool2 === void 0 ? void 0 : _events$onTool2.call(events, {
                  id: call.id,
                  name: call.name,
                  done: true,
                  args: call.argsRaw || undefined
                });
              },
              onToolResult: function onToolResult(call) {
                var _events$onTool3;
                return (_events$onTool3 = events.onTool) === null || _events$onTool3 === void 0 ? void 0 : _events$onTool3.call(events, {
                  id: call.id,
                  name: call.name,
                  done: true,
                  args: call.argsRaw || undefined,
                  result: call.result
                });
              }
            }, signal);
          case 2:
            result = _context.v;
            // Remember the thread for the next turn. Note that resuming one currently
            // degrades to a non-streaming call: orqestrator's /chat owns history but
            // is sync only, so only the first turn of a conversation truly streams.
            if (result.conversationId) {
              rememberThread(patientUid, result.conversationId);
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [client, userInfo, patientUid]);
  var loadHistory = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var id, page, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          id = recallThread(patientUid);
          if (id) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, []);
        case 1:
          _context2.p = 1;
          _context2.n = 2;
          return client.getHistory(id, {
            limit: 50
          });
        case 2:
          page = _context2.v;
          // A thread that no longer exists comes back empty; stop pointing at it so
          // the next turn opens a fresh one instead of resubmitting the missing id
          // and failing again until the user picks New Chat.
          if (page.messages.length === 0) rememberThread(patientUid, undefined);
          return _context2.a(2, page.messages);
        case 3:
          _context2.p = 3;
          _t = _context2.v;
          return _context2.a(2, []);
      }
    }, _callee2, null, [[1, 3]]);
  })), [client, patientUid]);

  // Only this patient's thread: starting a new chat for one patient must not
  // discard the conversations held for the others.
  var newThread = useCallback(function () {
    rememberThread(patientUid, undefined);
  }, [patientUid]);
  return {
    transport: transport,
    loadHistory: loadHistory,
    newThread: newThread,
    threadScope: threadKey(patientUid)
  };
}